<template>

  <NdsDlg
      v-if="selectedApplic"
      :isOpen.sync="isNdsDlgOpen"
      :application="selectedApplic"
      @update:isOpen="val => {
      isNdsDlgOpen = val;
      if (!val) selectedApplic = null;
    }"
  />

  <Card>
    <div class="cardTitle">{{ $t('Спецификация заказа') }}</div>
    <component
      v-if="customDataTableComponent"
      :is="customDataTableComponent"
      :items="result.positions"
    />
    <DataTableVirtual
      v-else
      hide-default-header
      :items="result.positions"
    >
      <template #item="{ item, itemRef }">
        <tr :ref="itemRef">
          <td>
            <v-row class="ma-0 align-center">
              <v-col class="specification_order_text">
                {{ item.name }}
              </v-col>
              <v-spacer/>
              <v-col class="specification_order_text">
                <span class="quantity-round">
                  {{ `${item.quantity} ${item.measure}` }}
                </span>
                <span>
                  * {{ filters.formatPrice(calculatePositionCost(item, result.ndsValue)) }}
                </span>
                <span v-if="!!result.ndsValue">
                    {{ ` + ${Number(result.ndsValue)}%` }}
                  </span>
                <span
                    class="specification_order_text_small"
                    :style="{ cursor: result.isNds ? 'pointer' : 'default' }"
                    @click.stop="result.isNds ? openDialog(result, item.amount) : null"
                >
                  {{ ` = ${filters.formatPrice(calculatePositionCost(item, result.ndsValue, item.quantity))}` }}
                </span>
              </v-col>
            </v-row>
          </td>
        </tr>
      </template>
    </DataTableVirtual>
    <v-row class="mt-6 justify-space-between" no-gutters>
      <v-btn
        class="h-auto pt-1 pb-1"
        color="primary"
        density="comfortable"
        variant="outlined"
        @click="downloadResults()"
      >
        <v-icon class="mr-1">custom:downloadFileIcon</v-icon>{{ $t('Скачать результаты') }}</v-btn>
      <div class="specification_order_text_offer-price">{{ $t('Итоговая сумма заказа:') }}
        <span class="specification_order_text_small">
          {{ filters.formatPrice(calculateApplicationCost(result)) }}
        </span>
      </div>
    </v-row>
  </Card>
</template>

<script>
import Card from "@intec/vue-components/form/Card.vue";
import {formatMoneyText, formatPrice} from "@/filters";
import NdsDlg from "@/components/application/dialogs/NdsDlg.vue";
import { useLibraryStore } from "@/stores/library";
import { useApplicationCalculator } from '@/lib/application';
import { useApplicationPositionCalculator } from '@/lib/applicationPosition';
import DataTableVirtual from "@intec/vue-components/table/DataTableVirtual.vue";
import { useSpecificationOrderComponentStore } from "@/stores/specificationOrderComponentStore";
import { useSpecificationOrderStore } from "@/stores/component/procedure/specificationOrderStore";

export default {
  name: "SpecificationOrder",
  components: {NdsDlg, Card, DataTableVirtual },

  props: {
    result: {
      type: Object,
      required: true
    },
    procedure: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      filters: {
        formatPrice: formatMoneyText,
      },
      selectedApplic: null,
      isNdsDlgOpen: false,
    }
  },

  setup(props) {
    const libraryStore = useLibraryStore();
    const specificationOrderComponentStore = useSpecificationOrderComponentStore();
    const specificationOrderStore = useSpecificationOrderStore();
    libraryStore.callActionByCode('getApplicationItemPriceField', {
      procedureType: props.procedure.type
    });
    const customDataTableComponent = specificationOrderComponentStore.getComponentByType(props.procedure.type);

    return {
      libraryStore,
      customDataTableComponent,
      specificationOrderStore,
    };
  },

  methods: {
    async downloadResults() {
      // Пытаемся получить ссылку от внешнего модуля.
      const overrideLink = this.libraryStore.callFunctionByCode('getLinkDownloadResults', {
        procedure: this.procedure
      }).linkDownloadResults ?? null;

      // Если модуль вернул строку — используем её, иначе дефолтную.
      window.location.href = typeof overrideLink === 'string'
        ? overrideLink
        : `/procedures/${this.procedure.id}/resultsExport`;
    },
    openDialog(result, offerPrice) {
      this.selectedApplic = {
        offerPrice: offerPrice,
        nds: {
          rate: result.ndsValue
        }
      };
      this.isNdsDlgOpen = true;
    },
    calculatePositionCost(position, ndsRate, quantity) {
      const calculator = useApplicationPositionCalculator(position, ndsRate);
      if (!quantity) {
        return calculator.getCostForQuantity(1);
      }
      return this.isEnabled  ? calculator.getCostForQuantity(quantity) : calculator.getCostNdsForQuantity(quantity);
    },
    calculateApplicationCost(application) {
      const calculator = useApplicationCalculator(
          application, application.positions,
          application.ndsValue,
          this.specificationOrderStore.applicationItemPriceField
      );
      return this.isEnabled ? calculator.getChosenCost() : calculator.getChosenCostNds();
    },
  }
}
</script>

<style scoped lang="scss">
:deep(.v-data-table .v-table__wrapper) {
  max-height: 500px;
}

:deep(.v-data-table .v-table__wrapper table) {
  table-layout: auto;
}

.specification_order_text {
  font-family: 'Manrope';
  font-weight: 500;
  font-size: 16px;
  min-width: fit-content;

  &_small {
    font-weight: 500;
    font-size: 20px;
    color: rgb(0, 0, 0);
  }

  &_offer-price {
    font-weight: 400;
    color: rgba(0, 0, 0, 0.6);
  }
}

  .quantity-round {
    font-family: var(--primary-font-family-name);
    border-radius: 25px;
    padding: 4px 20px;
    color: #162040;
    background-color: #C8CAD1;
  }
</style>